// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"a63e8aca","420":"75e353ca","782":"e650490e","787":"554784f9"}[chunkId] + ".chunk.js";
};